import { ViewModel } from 'view_models/view_model'
import { RequestFormIssuance } from 'entities/request_form_issuance'
import { Badge, ProgressBar } from 'react-bootstrap'

export class RequestFormIssuanceViewModel extends ViewModel<RequestFormIssuance> {
    public statusView = () => {
        if (this.object.status === 'CREATED') {
            return (
                <Badge bg="danger" style={{ padding: 10, fontSize: 11 }}>
                    未印刷
                </Badge>
            )
        } else if (this.object.status === 'PRINTED') {
            return (
                <Badge bg="secondary" style={{ padding: 10, fontSize: 11 }}>
                    送付済
                </Badge>
            )
        } else {
            return (
                <Badge bg="success" style={{ padding: 10, fontSize: 11 }}>
                    回収済
                </Badge>
            )
        }
    }
    // export type Variant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | string;

    public printedAtText = () => {
        return this.toDateTimeText(this.object.printedAt)
    }

    public collectedAtText = () => {
        return this.toDateTimeText(this.object.collectedAt)
    }

    public collectedRateView = () => {
        if (this.object.requestForms) {
            const progress = (this.object.requestForms.filter((r) => r.isCollected).length / this.object.requestForms.length) * 100
            return <ProgressBar variant="success" label={Math.round(progress) + '%'} now={progress} style={{ margin: 0 }} />
        } else {
            return <div>-</div>
        }
    }

    public sentRateView = () => {
        if (this.object.requestForms) {
            const progress = Math.floor((this.object.requestForms.filter((r) => !!r.sentAt).length / this.object.requestForms.length) * 100)
            return <ProgressBar variant="success" label={Math.round(progress) + '%'} now={progress} style={{ margin: 0 }} />
        } else {
            return <div>-</div>
        }
    }
}
